import * as React from "react";
import GlobalStyles from "@mui/joy/GlobalStyles";
import Avatar from "@mui/joy/Avatar";
import Box from "@mui/joy/Box";
import Divider from "@mui/joy/Divider";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import ListItemButton, { listItemButtonClasses } from "@mui/joy/ListItemButton";
import ListItemContent from "@mui/joy/ListItemContent";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { closeSidebar } from "../utils/utils";
import { AddRounded, DownloadOutlined, Report } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import useLogin from "../hooks/useLogin";
import { useGetFetchUserManualMutation } from "../services/vendor/VendorApi";
import { toast } from "react-toastify";

export default function Sidebar() {
  const navigate = useNavigate();
  const { handleLogout } = useLogin();

  const [getUserManual] = useGetFetchUserManualMutation();


  const openUserManual = async () => {
    try {
      const response = await getUserManual(5);
      if (response?.data?.success) {

        const { data, file_name, mime_type, presigned_url } = response?.data?.file;
        window.open(presigned_url, "_blank");

        // Clean up the URL after a short delay to allow the browser to load it
        setTimeout(() => {
          URL.revokeObjectURL(presigned_url);
        }, 1000);
      }
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
    }
  }

  return (
    <Sheet
      style={{ background: "#e6eef3" }}
      className="Sidebar"
      sx={{
        position: { xs: "fixed", md: "sticky" },
        right: 0,
        transform: {
          xs: "translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1)))",
          md: "none",
        },
        transition: "transform 0.4s, width 0.4s",
        zIndex: 1000,
        height: { xs: "100dvh", md: "100vh" },
        width: "var(--Sidebar-width)",
        top: 0,
        p: 2,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        borderRight: "1px solid",
        borderColor: "divider",
      }}
    >
      <GlobalStyles
        styles={(theme) => ({
          ":root": {
            "--Sidebar-width": "220px",
            [theme.breakpoints.up("lg")]: {
              "--Sidebar-width": "240px",
            },
          },
        })}
      />
      <Box
        className="Sidebar-overlay"
        sx={{
          position: "fixed",
          zIndex: 9998,
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          opacity: "var(--SideNavigation-slideIn)",
          backgroundColor: "var(--joy-palette-background-backdrop)",
          transition: "opacity 0.4s",
          transform: {
            xs: "translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1) + var(--SideNavigation-slideIn, 0) * var(--Sidebar-width, 0px)))",
            lg: "translateX(-100%)",
          },
        }}
        onClick={() => closeSidebar()}
      />
      <Box
        sx={{
          minHeight: 0,
          overflow: "hidden auto",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          [`& .${listItemButtonClasses.root}`]: {
            gap: 1.5,
          },
        }}
      >
        <Typography level="body-xs">{localStorage.getItem("userRole") === "employee" ? "Employee" : "Vendor"}</Typography>
        <List
          size="sm"
          sx={{
            gap: 1,
            "--List-nestedInsetStart": "30px",
            "--ListItem-radius": (theme) => theme.vars.radius.sm,
          }}
        >
          <ListItem>
            <ListItemButton onClick={() => navigate("/landing_page")}>
              <HomeRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">Dashboard</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>

          <ListItem onClick={() => navigate("/bills")}>
            <ListItemButton>
              <ShoppingCartRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">My Request</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>
          <ListItem onClick={() => navigate("/add-new-entry")}>
            <ListItemButton>
              <AddRounded />
              <ListItemContent>
                <Typography level="title-sm">Add Entry</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>
          {/* <ListItem>
            <ListItemButton>
              <DownloadOutlined />
              <ListItemContent>
                <Typography level="title-sm">Download TDS Certificate</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem> */}
          <ListItem onClick={() => navigate("/tds-file-download")}>
            <ListItemButton>
              <DownloadOutlined />
              <ListItemContent>
                <Typography level="title-sm">TDS Certificate</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>
          <ListItem>
            <ListItemButton onClick={openUserManual}>
              <Report />
              <ListItemContent>
                <Typography level="title-sm">User Manual</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>
          <ListItem>
            <ListItemButton onClick={handleLogout}>
              <LogoutRoundedIcon />
              <ListItemContent>
                <Typography level="title-sm">Logout</Typography>
              </ListItemContent>
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
      <Divider />
    </Sheet>
  );
}
